module.exports = __webpack_public_path__ + "static/media/log-out.7e1c31f0.svg";